import Vue from 'vue'
import Router from 'vue-router'
// import HomeUsage from '@/views/HomeUsage.vue'
import HomeIntro from '@/views/HomeIntro.vue'
// import AboutUs from '@/views/AboutUs.vue'
// import HomeFees from '@/views/HomeFees.vue'
// import HomeBrands from '@/views/HomeBrands.vue'
import BussinessCooperator from '@/views/NewsPage.vue'
import AdvertisingPlatform from '@/views/AdvertisingPlatform.vue'
import contactUS from '@/views/contactUS.vue'
import FAQ from '@/views/FAQ.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
  //   {
  //   path: '/about',
  //   component: () => import('@/views/AboutUs.vue'),
  //   children: [
  //     {
  //       path: '', // 默认路径
  //       redirect: 'service'
  //     },
  //     {
  //       path: 'service',
  //       component: () => import('@/views/AboutUs.vue'),
  //       meta: { anchor: 'right-images' }  // 服务介绍
  //     },
  //     {
  //       path: 'usage',
  //       component: () => import('@/views/AboutUs.vue'),
  //       meta: { anchor: 'row-first' }  // 使用方法
  //     },
  //     {
  //       path: 'fee',
  //       component: () => import('@/views/AboutUs.vue'),
  //       meta: { anchor: 'row-second' }  // 收费方式
  //     }
  //   ]
  // },
      // { path: '/home/AboutUs', component: AboutUs },
    { path: '/home/intro', component: HomeIntro },
    // { path: '/about', component: AboutUs }, // 路由到关于我们页面
    // { path: '/home/usage', component: HomeUsage },
    // { path: '/home/fees', component: HomeFees },
    // { path: '/home/brands', component: HomeBrands },
    { path: '/bussinesscooperator', component: BussinessCooperator },
    { path: '/advertisingPlatform', component: AdvertisingPlatform },
    { path: '/contactUS', component: contactUS },
    { path: '/faq', component: FAQ }
  ]
})